import { useCallback } from 'react'
import { AnalyticsEventProperties } from 'core/analytics/analytics-types'
import { TrajectoryEvent } from 'core/constants/trajectory-analytics'
import { trackTrajectoryEvent } from './track-trajectory-event'

export const useTrajectoryAnalytics = () => {
  return useCallback((event: TrajectoryEvent, properties?: AnalyticsEventProperties) => {
    trackTrajectoryEvent(event, properties)
  }, [])
}
